import { useEffect, useState } from 'preact/hooks';

/**
 * Debounces rapidly changing values so network-backed search hooks can avoid
 * firing a request on every keypress.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timeoutId = globalThis.setTimeout(() => {
      setDebounced(value);
    }, delayMs);

    return () => globalThis.clearTimeout(timeoutId);
  }, [value, delayMs]);

  return debounced;
}
